import React, { useContext, useCallback } from 'react';
import { AppContext, IAppContext } from 'appState/appContext';
import { convertUndefinedFields } from 'utils/helpers';
import {
	IEditSubcategoryRestaurantPropertiesContext,
	EditSubcategoryRestaurantPropertiesContext,
} from '../../editSubcategoryRestaurantPropertiesState/editSubcategoryRestaurantPropertiesContext';
import { ModalWrapper } from 'components/ModalWindows/ModalWrapper';
import { ModalToConfirm } from 'components/ModalWindows/ModalToConfirm';
import ModalSentSuccessfully from 'components/ModalWindows/ModalSentSuccessfully';
import ModalSentError from 'components/ModalWindows/ModalSentError';
import { SaveAsPatchModal } from './SaveAsPatchModal/index';
import { ModalAssignDishesToSubcategory } from 'components/ModalWindows/ModalAssignDishesToSubcategory';
import { updateSubcategoryRestaurantProperties } from 'backend/subcategories';
import { useHistory } from 'react-router-dom';

export const ModalWindows: React.FC = () => {
	const { showLoader, hideLoader } = useContext<IAppContext>(AppContext);
	const {
		changeTypeOfModalWindow,
		refetchRestPropsData,
		dataForSubmit,
		typeOfModalWindow,
		IDSelectedRestaurant,
		subcategoryId,
		customerName,
		categoryName,
		fetchedRestaurants,
	} = useContext<IEditSubcategoryRestaurantPropertiesContext>(EditSubcategoryRestaurantPropertiesContext);
	const history = useHistory();

	const handleConfirm = useCallback(async () => {
		if (dataForSubmit) {
			try {
				const convertedData = convertUndefinedFields(dataForSubmit);
				showLoader();
				await updateSubcategoryRestaurantProperties(convertedData);
				changeTypeOfModalWindow('success');
			} catch (err) {
				changeTypeOfModalWindow('error');
			} finally {
				hideLoader();
			}
		}
	}, [dataForSubmit]);

	const handleCloseModal = useCallback(() => {
		changeTypeOfModalWindow(null);
	}, [changeTypeOfModalWindow]);

	const handleCloseModalWithRefetchRestPropsData = useCallback(() => {
		refetchRestPropsData(true);
		changeTypeOfModalWindow(null);
	}, [refetchRestPropsData, changeTypeOfModalWindow]);

	const handleCloseModalWithError = useCallback(() => {
		changeTypeOfModalWindow('error');
	}, [changeTypeOfModalWindow]);

	return (
		<ModalWrapper isVisible={!!typeOfModalWindow}>
			{typeOfModalWindow === 'toConfirmFieldsClearing' && (
				<ModalToConfirm
					onConsentEvent={() => history.push(`/menu-v2/subcategory/view?subcategoryID=${subcategoryId}`)}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="cancelSaveInfo"
				/>
			)}
			{typeOfModalWindow === 'toConfirmSubmit' && (
				<ModalToConfirm
					onConsentEvent={handleConfirm}
					onFailureEvent={handleCloseModal}
					isVisible={true}
					description="saveInfo"
				/>
			)}
			{typeOfModalWindow === 'success' && (
				<ModalSentSuccessfully
					onConsentEvent={handleCloseModal}
					isVisible={true}
					description="savedSuccessfully"
				/>
			)}
			{typeOfModalWindow === 'error' && (
				<ModalSentError onConsentEvent={handleCloseModal} isVisible={true} description="errorWhileSaving" />
			)}
			{typeOfModalWindow === 'saveAsPatch' && (
				<SaveAsPatchModal onCloseModal={handleCloseModalWithRefetchRestPropsData} />
			)}
			{typeOfModalWindow === 'assignDishes' && IDSelectedRestaurant && (
				<ModalAssignDishesToSubcategory
					onCloseModal={handleCloseModalWithRefetchRestPropsData}
					onFailureEvent={handleCloseModal}
					onShowError={handleCloseModalWithError}
					subcategoryID={subcategoryId}
					customerName={customerName || '-'}
					categoryName={categoryName || '-'}
					restaurantsOfSubcategory={fetchedRestaurants}
					restaurantIdForRestaurantProps={IDSelectedRestaurant}
				/>
			)}
		</ModalWrapper>
	);
};
